import React from 'react';

import { INVITATION_REQUIRED } from '../../constants';

class InviteOnlyCTA extends React.Component {
    componentDidMount = () => {
        if (this.inviteCTANode) {
            this._ctaLinkNode = this.inviteCTANode.querySelector(
                '#invitation-protected-cta-eb-link',
            );
            this._ctaLinkNode.addEventListener('click', this._onCTAClick);
        }
    };

    componentWillUnmount = () => {
        if (this.inviteCTANode) {
            this._ctaLinkNode.removeEventListener('click', this._onCTAClick);
        }
    };

    _onCTAClick = () => {
        this.props.onCTAClick(
            INVITATION_REQUIRED,
            this.props.eventId,
            this.props.eventUrl,
        );
    };

    inviteCTANode = null;
    setInviteCTARef = (element) => {
        this.inviteCTANode = element;
    };

    render() {
        const { ctaText } = this.props;

        return (
            <div className="eds-g-cell-9-12 eds-g-cell-sm-6-12 eds-g-cell-md-5-12 eds-g-cell-ln-3-12 eds-g-cell-lw-2-12">
                <p
                    ref={this.setInviteCTARef}
                    className="eds-l-mar-top-6 eds-text-bm eds-text-weight--regular eds-text-color--grey-600"
                    // Needed for links to work in gettext; no user-generated content
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: ctaText.toString(),
                    }}
                />
            </div>
        );
    }
}

export default InviteOnlyCTA;
